import { render, staticRenderFns } from "./Landscape.vue?vue&type=template&id=22320106&scoped=true&"
import script from "./Landscape.vue?vue&type=script&lang=js&"
export * from "./Landscape.vue?vue&type=script&lang=js&"
import style0 from "./Landscape.vue?vue&type=style&index=0&id=22320106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22320106",
  null
  
)

export default component.exports